import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { Box, Typography } from "@mui/material";
import { Gauge, gaugeClasses } from "@mui/x-charts";
import React, { Fragment } from "react";
import CommonLinearProgress from "../../../../component/Linearprogress";
import { CustomDiv } from "../../../chat-bot/style";
import {
  CommonGrid2,
  DotColor,
  StatusChange,
} from "../../../common-components/StyledComponents";
import {
  FileContainer,
  StyledLinearContainer,
  StyledSpaceBetweenBox,
} from "../../../matches/quick-match/components/StyledComponent";
import { CommonTippy } from "../../style";

export default function CandidateProgress({ checkSelected }) {
  return (
    <Fragment>
      {checkSelected &&
        checkSelected.map((item, index) => {
          return (
            <CommonGrid2
              container
              spacing={2}
              justifyContent={"space-between"}
              marginTop={2}
              alignItems={"center"}
              borderRadius="10px"
              border={"1px solid #EAECF0"}
              padding={"10px"}
            >
              {item.result_title === "Candidate Search Results" && (
                <CommonGrid2
                  item
                  display={"flex"}
                  gap={"1rem"}
                  alignItems={"center"}
                >
                  <CommonGrid2
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                  >
                    <Gauge
                      width={80}
                      height={80}
                      value={item.relevancy_score}
                      valueMax={100}
                      cornerRadius="50%"
                      text={({ value, valueMax }) => `${item.relevancy_score}%`}
                      sx={(theme) => ({
                        [`& .${gaugeClasses.valueText}`]: {
                          fontSize: 12,
                          color: "#101828",
                          fontWeight: 600,
                        },
                        [`& .${gaugeClasses.valueArc}`]: {
                          fill: "green",
                        },
                      })}
                    />
                    <Typography variant="p">Relevancy</Typography>
                  </CommonGrid2>
                  <CommonGrid2
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"10px"}
                  >
                    <CommonGrid2
                      display={"flex"}
                      alignItems={"center"}
                      gap={"10px"}
                      height={"max-content"}
                    >
                      <Typography variant="h5">
                        {item?.name || item?.title}
                      </Typography>
                      <StatusChange>
                        <DotColor
                          color={
                            //   row.status === "Active"
                            //     ?
                            "green"
                            // : row.status === "Hold"
                            // ? "orange"
                            // : "#667085"
                          }
                        />
                        {"Active" || "-"}
                      </StatusChange>
                    </CommonGrid2>
                    <CommonGrid2
                      display={"flex"}
                      gap={"10px"}
                      flexWrap={"wrap"}
                    >
                      {(item &&
                        item.match_criteria_normal &&
                        item.match_criteria_normal.map((item) => {
                          return (
                            <CustomDiv
                              border="1px solid #AAEFC6"
                              padding="4px"
                              background="#ECFDF3"
                              borderRadius="4px"
                              fontSize="12px"
                              color="#067647"
                            >
                              {item}
                            </CustomDiv>
                          );
                        })) ||
                        "-"}
                    </CommonGrid2>
                  </CommonGrid2>
                </CommonGrid2>
              )}
              <CommonGrid2 item>
                {item.file && (
                  <FileContainer
                    elevation={1}
                    gap={"1rem"}
                    width="200px"
                    padding="12px 16px"
                    borderRadius="8px"
                    margin="0px"
                  >
                    <Box width={item.file.progress === 100 ? "aauto" : "300px"}>
                      {item.file.progress === 100 ? (
                        <CommonGrid2 display={"flex"} gap={"10px"}>
                          <TaskAltIcon sx={{ color: "#17B26A" }} />
                          <Typography variant="h5" color="#17B26A">
                            Added to Job
                          </Typography>
                        </CommonGrid2>
                      ) : (
                        <Fragment>
                          <StyledSpaceBetweenBox>
                            <Typography
                              color="#101828"
                              fontSize={"14px"}
                              style={{ wordBreak: "break-word" }}
                            >
                              Scoring in Progress
                            </Typography>
                          </StyledSpaceBetweenBox>
                          <Typography
                            color="#475467"
                            fontSize={"14px"}
                            fontWeight={500}
                          >
                            {item.file.size}
                          </Typography>
                          {(item.file.progress >= 0 || item.file.visible) && (
                            <CommonTippy
                              content={item.file.message}
                              visible={item.file.visible}
                              interactive={true}
                              trigger="click"
                              hideOnClick={false}
                              zIndex={2}
                              color="red"
                            >
                              <StyledLinearContainer>
                                <CommonLinearProgress
                                  variant={
                                    item.file.progress && !item.file.visible
                                      ? "buffer"
                                      : "determinate"
                                  }
                                  value={item.file.progress}
                                  valueBuffer={item.file.buffer}
                                  height={"8px"}
                                  borderRadius={"2px"}
                                  backgroundColor={"#E0E0E0"}
                                  barbackgroundColor={
                                    item.file.visible ? "red" : "#7F56D9"
                                  }
                                  dashedmarginTop={"2px"}
                                  dashedbackgroundImage={
                                    item.file.visible
                                      ? "radial-gradient(rgb(255 46 0) 0%, rgb(255 0 0) 16%, #00000000 42%)"
                                      : "radial-gradient(rgb(82 0 255) 0%, rgb(82 0 255) 16%, #00000000 42%)"
                                  }
                                />

                                <Typography
                                  color="#344054"
                                  fontSize={"14px"}
                                  fontWeight={500}
                                >
                                  {item.file.progress}%
                                </Typography>
                              </StyledLinearContainer>
                            </CommonTippy>
                          )}
                        </Fragment>
                      )}
                    </Box>
                  </FileContainer>
                )}
              </CommonGrid2>
            </CommonGrid2>
          );
        })}
    </Fragment>
  );
}
